<a href="#main-content" class="govuk-skip-link" data-module="govuk-skip-link" (click)="skipToMainContent($event)">Skip to main content</a>
<header>
  <app-header *ngIf="this.dataStore.config && this.dataStore.config !== 'false'"></app-header>
</header>

<!-- <app-member-bar></app-member-bar> -->
<div *ngIf="loadIssue" class="govuk-width-container" style="overflow: auto;">

  <div class="govuk-error-summary" aria-labelledby="error-summary-title" role="alert" data-disable-auto-focus="true"
    data-module="govuk-error-summary">
    <div class="govuk-error-summary__body">
      <ul class="govuk-list govuk-error-summary__list">
        <li>
          <p class="warning-message">{{this.translatorService.getText('errorWarn')}}</p>
          <button class="govuk-button govuk-button--secondary"
            (click)="resetApp()">{{this.translatorService.getText('retry')}}</button>
          <ol>
            <li *ngFor="let error of this.errors">
              <p>{{error}}</p>
            </li>
          </ol>
        </li>
      </ul>
    </div>
  </div>
</div>

<router-outlet></router-outlet>

<app-footer *ngIf="this.dataStore.config && this.dataStore.config !== 'false'"></app-footer>
<div role="status" aria-live="polite">
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-beat" [fullScreen]="true">
    <p style="color: white"> Loading... Do not close this window. Closing your browser now may result in data loss or an incomplete update. </p>
    <div  class="visually-hidden">
      Loading... Do not close this window. Closing your browser now may result in data loss or an incomplete update.
    </div>
  </ngx-spinner>
</div>
  
